var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLines(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1080,
    height: 1350,
    viewBox: "0 0 1080 1350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7089_277)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M183 -1L183 1350",
    stroke: "url(#paint0_linear_7089_277)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M257 -1L257 1350",
    stroke: "url(#paint1_linear_7089_277)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M1080 424L-101 424",
    stroke: "url(#paint2_linear_7089_277)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257,
    cy: 424,
    r: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M896 -1L896 1350",
    stroke: "url(#paint3_linear_7089_277)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M822 -1L822 1350",
    stroke: "url(#paint4_linear_7089_277)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M1080 945L-101 945",
    stroke: "url(#paint5_linear_7089_277)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257,
    cy: 945,
    r: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-1 0 0 1 824 943)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M1080 1044H-101",
    stroke: "url(#paint6_linear_7089_277)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257,
    cy: 1044,
    r: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-1 0 0 1 824 1042)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-1 0 0 1 824 422)",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7089_277",
    x1: 183.5,
    y1: -1,
    x2: 183.5,
    y2: 1350,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682692,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951923,
    stopColor: "#A7A7A7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7089_277",
    x1: 257.5,
    y1: -1,
    x2: 257.5,
    y2: 1350,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682692,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951923,
    stopColor: "#A7A7A7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7089_277",
    x1: 1080,
    y1: 424.5,
    x2: -101,
    y2: 424.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0827293,
    stopColor: "#C9C9C9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17157,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682692,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820949,
    stopColor: "#A7A7A7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7089_277",
    x1: 895.5,
    y1: -1,
    x2: 895.5,
    y2: 1350,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682692,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951923,
    stopColor: "#A7A7A7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7089_277",
    x1: 821.5,
    y1: -1,
    x2: 821.5,
    y2: 1350,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682692,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951923,
    stopColor: "#A7A7A7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7089_277",
    x1: 1080,
    y1: 945.5,
    x2: -101,
    y2: 945.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0827293,
    stopColor: "#C9C9C9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17157,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682692,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820949,
    stopColor: "#A7A7A7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7089_277",
    x1: 1080,
    y1: 1044.5,
    x2: -101,
    y2: 1044.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0827293,
    stopColor: "#C9C9C9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17157,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682692,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820949,
    stopColor: "#A7A7A7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7089_277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 1350,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines);
export default __webpack_public_path__ + "static/media/lines.eec01077848de0566631bdbe4811a4f2.svg";
export { ForwardRef as ReactComponent };